interface Props {
  plot: { code: string, year: number } | null | undefined
}

export const PlotLabel = ({ plot }: Props) => <>
  { plot && <div><span className="block" style={{ backgroundColor: plot.year % 2 === 0 ? "#b2ff66" : "#66b2ff" }} /> {plot.code}</div> }
  </>;